export default __webpack_public_path__ + "static/media/D372C422-9DB2-471B-B221-4702EEF89CA6.aefabdb5.mov";